// extracted by mini-css-extract-plugin
export default {"document":"Document_document__Gjm2L","link":"Document_link__fiQ53","icon":"Document_icon__xbtI5","size":"Document_size__Xuzzk","name":"Document_name__Btolw"};